import type { Recital } from "@recital-master/shared";

import { useCatalog } from "@/data/CatalogProvider";
import { recitalPathSlug } from "@/lib/routePaths";

export {
  dancersPath,
  performancePath,
  recitalPath,
  recitalPathSlug
} from "@/lib/routePaths";

/**
 * URL structure speaks the family's language, never the data model's:
 *
 *   /recitals                                 → all recitals
 *   /marquis/showstoppers-2026                → one recital
 *   /marquis/showstoppers-2026/recital-1      → one performance
 *   /marquis/showstoppers-2026/dancers        → dancer picker for the recital
 */

/** Resolves the studio-scoped public URL back to its recital. */
export function useRecitalBySlug(
  studioSlug: string | undefined,
  recitalSlug: string | undefined
): Recital | null {
  const { catalog } = useCatalog();
  if (!catalog || !studioSlug || !recitalSlug) return null;
  return (
    catalog.recitals.find(
      (recital) =>
        recital.studioSlug === studioSlug &&
        recitalPathSlug(recital) === recitalSlug
    ) ??
    null
  );
}

/** The recital a given performance belongs to. */
export function useRecitalForPerformance(performanceId: string | undefined): Recital | null {
  const { catalog } = useCatalog();
  if (!catalog || !performanceId) return null;
  const performance = catalog.performances.find((entry) => entry.performanceId === performanceId);
  return performance ? catalog.recitals.find((recital) => recital.recitalId === performance.recitalId) ?? null : null;
}
